module.exports = __webpack_public_path__ + "static/media/arrow_up.e2c82cce.svg";